import { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const RemoveTrailingSlashRedirect: FC = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.length > 1 && pathname.endsWith("/")) {
      navigate(pathname.slice(0, -1) + search, { replace: true });
    }
  }, [pathname, search, navigate]);

  return null;
};
